import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FilterSettingsModel, GridComponent, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { CloseEventArgs, DialogComponent } from '@syncfusion/ej2-angular-popups';
import { Observable, Subject, filter, finalize, switchMap, tap } from 'rxjs';
import { HISTORICO } from 'src/app/i18n/constantes';
import { ConfirmService } from 'src/app/libs/confirm/confirm.service';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { AtendimentoService } from 'src/app/servicos/atendimento.service';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { PessoaDoencaService } from 'src/app/servicos/pessoa-doenca.service';
import { ToolbarService } from 'src/app/utilitarios/toolbar.service';

@Component({
  selector: 'app-doenca-historico-lista',
  templateUrl: './doenca-historico-lista.component.html',
  styleUrls: ['./doenca-historico-lista.component.less']
})
export class DoencaHistoricoListaComponent implements OnInit {

  pacienteNome: string | null = null;

  @Input() 
  target: string = 'body';

  @ViewChild('grid')
  grid!: GridComponent;

  pessoaId: number = 0;
  doencas: any[] = [];
  doencaSelecionadaId: number | null = null;
  todasDoencas: boolean = false;

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }

  toolbarItens: Object[] | null = null;

  @ViewChild('modal')
  modal!: DialogComponent;

  abriuModal: boolean = false;

  emOperacao: boolean = false;

  registros: object[] = [];

  assunto: Subject<boolean> = new Subject<boolean>();
  
  @Output()
  fechou: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private translate: TranslateService,
    private paciente: PacienteService,
    public toolbar: ToolbarService,
    private pessoaDoenca: PessoaDoencaService,
    private toast: ToastService,
    private confirm: ConfirmService) { }

  ngOnInit(): void {
    this.translate.getTranslation('pt').subscribe(() => {
      this.toolbarItens = this.criarToolbar(); 
    });

    this.paciente.consultarPacienteEmCache().subscribe((paciente) => {
      this.pacienteNome = paciente.nome;
    });
  }
  
  criarToolbar(): Object[] {
    return [
      'Search', 'ExcelExport', 'CsvExport', 'PdfExport',
      { type: 'Separator' },
      { id: 'excluir', text: this.translate.instant(HISTORICO.ACAO.EXCLUSAO), prefixIcon: 'fal fa-times' },
    ];
  }

  toobarClick(event: ClickEventArgs) {
    if (event.item.id === 'excluir') {
      this.excluir();
    }
  }
  
  excluir() {
    if (this.grid.getSelectedRecords().length === 0) {
      this.toast.showInfo('Selecione um histórico.');
      return;
    }

    let id = (this.grid.getSelectedRecords()[0] as any).id;

    this.confirm.confirm()
    .pipe(
      filter(x => x===true),
      switchMap(x => this.pessoaDoenca.excluirHistorico(id)),
      tap(() => {
        this.toast.showSuccess('Histórico excluído com sucesso.');
      }),
      finalize(() => {
        this.carregar();
      })
    )
    .subscribe()
  }

  abrir(pessoaId: number, pessoaCidId?: number): Observable<boolean> {
    this.pessoaId = pessoaId;
    //this.doencaSelecionadaId = pessoaCidId || null;
    this.todasDoencas = !pessoaCidId;

    // Carregar todas as doenças da pessoa primeiro
    this.pessoaDoenca.listarTodasDoencas(pessoaId).subscribe((doencas) => {
      this.doencas = doencas;
      this.doencaSelecionadaId = pessoaCidId || null;

      console.log('Doenças carregadas:', this.doencas);
      console.log('PessoaCidId recebido:', pessoaCidId);
      console.log('DoencaSelecionadaId final:', this.doencaSelecionadaId);
      
      // Abrir o modal
      this.modal.show(true);
      
      // Carregar históricos após doenças serem carregadas
      setTimeout(() => {
        this.carregar();
      }, 150);
    });

    return new Observable((subscriber) => {
      let subs = this.assunto.subscribe((val) => {
        subs.unsubscribe();
        subscriber.next(val);
        subscriber.complete();
      });

      return { unsubscribe: () => subs.unsubscribe() }
    })
  } 

  doencasCarregadas() {
  }

  fechandoModal(args: CloseEventArgs) {
    if(this.emOperacao) {
      args.cancel = true;
      return;
    }

    this.fechou.emit();
    this.assunto.next(true);
  }
  
  carregar() {
    if (this.todasDoencas) {
      // Listar históricos de todas as doenças da pessoa
      this.pessoaDoenca.listarHistoricos(undefined, this.pessoaId).subscribe((historicos) => {
        this.registros = historicos;
      });
    } else if (this.doencaSelecionadaId) {
      // Listar históricos de uma doença específica
      this.pessoaDoenca.listarHistoricos(this.doencaSelecionadaId).subscribe((historicos) => {
        this.registros = historicos;
      });
    }
  }

  onDoencaChange(event: any) {
    this.doencaSelecionadaId = event.value;
    if (this.doencaSelecionadaId) {
      this.todasDoencas = false;
    }
    this.carregar();
  }

  onTodasDoencasChange(event: any) {
    this.todasDoencas = event.checked;
    if (this.todasDoencas) {
      this.doencaSelecionadaId = null;
    }
    this.carregar();
  }

  getDoencaTexto(doenca: any): string {
    return `${doenca.id} - ${doenca.cid10Texto}`;
  }
}
